import React, { Component, MouseEvent } from 'react';
import styled from 'styled-components';
import { themes } from 'kb-shared';
const { colors } = themes;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 12px;
  overflow: hidden;
  flex-wrap: wrap;
  justify-content: center;
`;

type Props<T> = {
  mobile?: boolean;
  options: T[];
  extractTitle: (item: T) => string;
  selectedTitle?: string;
  onSelect: (item: T) => void;
};

export default class SegmentedControl<T> extends Component<Props<T>> {
  static defaultProps: Props<unknown> = {
    options: [],
    extractTitle: (_: unknown) => '',
    onSelect: (_: unknown) => {}
  };

  render() {
    const selectedTitle =
      this.props.selectedTitle || this.props.extractTitle(this.props.options[0]);

    return (
      <Container>
        {this.props.options.map(item => {
          const title = this.props.extractTitle(item);
          return (
            <Segment
              mobile={this.props.mobile}
              onClick={_ => {
                this.props.onSelect(item);
              }}
              key={title}
              text={title}
              selected={title === selectedTitle}
            />
          );
        })}
      </Container>
    );
  }
}

// Segment Component

interface SegmentPieceProps {
  selected?: boolean;
  mobile?: boolean;
}

const SegmentPiece = styled.div`
  height: 48px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 12px;
  padding-right: 12px;
  :nth-child(odd) {
    margin-left: 2px;
    margin-right: 2px;
  }
  box-sizing: content-box;

  :first-of-type {
    border-radius: 12px 0 0 12px;
  }
  :last-of-type {
    border-radius: 0 12px 12px 0;
  }

  ${({ selected, mobile }: SegmentPieceProps) => `
    background-color: ${selected ? colors.KBYellow : colors.KBBeige};
    :hover {
      background-color: ${selected ? colors.KBYellow : colors.KBPaleYellow};
    }
    min-width: ${mobile ? '80px' : '88px'};
    max-width: ${mobile ? '82px' : 'auto'};
  `}

  transition: all 400ms ease 0s;

  @media screen and (min-width: 375px) {
    min-width: 30px;
    max-width: 80px;
    padding: 0px 10px 0px 10px;
  }
`;

const SegmentText = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-size: 14px;
  color: ${colors.KBNight};
  text-align: center;
  text-transform: uppercase;
`;

type SegmentProps = {
  selected: boolean;
  text: string;
  onClick: (arg0: MouseEvent) => void;
  mobile?: boolean;
};

const Segment = (props: SegmentProps) => {
  return (
    <SegmentPiece selected={props.selected} onClick={props.onClick} mobile={props.mobile}>
      <SegmentText>{props.text}</SegmentText>
    </SegmentPiece>
  );
};
